import React from 'react';

const LanguageModal = ({ showModal, onLanguageSelect, translations }) => {
  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-pink-500/90 to-purple-600/90 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-4 transform animate-pulse-slow">
        <div className="text-center">
          <div className="text-6xl mb-4 animate-pulse-slow">🍰</div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Choose Your Language</h2>
          <p className="text-gray-600 mb-8">Select the language you prefer</p>
          <div className="space-y-4">
            <button
              onClick={() => onLanguageSelect('en')}
              className="w-full bg-gradient-to-r from-pink-400 to-pink-600 text-white py-4 px-6 rounded-full font-semibold text-lg hover:from-pink-500 hover:to-pink-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
            >
              🇬🇧 English
            </button>
            <button
              onClick={() => onLanguageSelect('ro')}
              className="w-full bg-gradient-to-r from-purple-400 to-purple-600 text-white py-4 px-6 rounded-full font-semibold text-lg hover:from-purple-500 hover:to-purple-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
            >
              🇷🇴 Română
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;